import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {UploadableForm, UploadableFormApiDetailInput, UploadableFormInput,} from './uploadable-form.model';

export const loadUploadableForms = createAction(
  '[UploadableForm/API] Load UploadableForms',
  props<{ uploadableForms: UploadableForm[] }>()
);

export const addUploadableForm = createAction(
  '[UploadableForm/API] Add UploadableForm',
  props<{ uploadableForm: UploadableForm }>()
);

export const upsertUploadableForm = createAction(
  '[UploadableForm/API] Upsert UploadableForm',
  props<{ uploadableForm: UploadableForm }>()
);

export const addUploadableForms = createAction(
  '[UploadableForm/API] Add UploadableForms',
  props<{ uploadableForms: UploadableForm[] }>()
);

export const upsertUploadableForms = createAction(
  '[UploadableForm/API] Upsert UploadableForms',
  props<{ uploadableForms: UploadableForm[] }>()
);

export const updateUploadableForm = createAction(
  '[UploadableForm/API] Update UploadableForm',
  props<{ uploadableForm: Update<UploadableForm> }>()
);

export const updateUploadableForms = createAction(
  '[UploadableForm/API] Update UploadableForms',
  props<{ uploadableForms: Update<UploadableForm>[] }>()
);

export const deleteUploadableForm = createAction(
  '[UploadableForm/API] Delete UploadableForm',
  props<{ id: string }>()
);

export const deleteUploadableForms = createAction(
  '[UploadableForm/API] Delete UploadableForms',
  props<{ ids: string[] }>()
);

export const clearUploadableForms = createAction(
  '[UploadableForm/API] Clear UploadableForms'
);

// CUSTOM
export const createUploadableForm = createAction(
  '[UploadableForm/API] Create UploadableForm',
  props<{ input: UploadableFormInput }>()
);

export const editUploadableForm = createAction(
  '[UploadableForm/API] Edit UploadableForm',
  props<{ input: UploadableFormInput }>()
);

export const removeUploadableForm = createAction(
  '[UploadableForm/API] Remove UploadableForm',
  props<{ formUniqueId: string; id: string }>()
);

export const getUploadableForms = createAction(
  '[UploadableForm/API] get UploadableForms',
  props<{ filtering?: {
      institutionUniqueId?: string;
      formUniqueId?: string;
    } }>()
);

// CITIZEN
export const citizenGetServiceUploadableForm = createAction(
  '[UploadableForm/API] Citizen Get UploadableForm',
  props<{ serviceUniqueId: string }>()
);

export const createUploadableFormApiDetails = createAction(
  '[UploadableForm/API] create Uploadable Form Api Details',
  props<{ input: UploadableFormApiDetailInput }>()
);

// CUSTOM
export const publishUploadableForm = createAction(
  '[UploadableForm/API] publish Uploadable Form',
  props<{ input: {
      formUniqueId: string;
      formIsPublished: boolean;
    } }>()
);
